import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Listener token is stored SEPARATELY from the author token ("cs_token"), so the two
// account systems never collide on the same device.
const KEY = "cs_listener_token";
export const getLToken = () => { try { return sessionStorage.getItem(KEY) || localStorage.getItem(KEY); } catch { return null; } };
export const setLToken = (t, remember = true) => {
  try {
    localStorage.removeItem(KEY); sessionStorage.removeItem(KEY);
    (remember ? localStorage : sessionStorage).setItem(KEY, t);
  } catch { /* ignore */ }
};
export const clearLToken = () => { try { localStorage.removeItem(KEY); sessionStorage.removeItem(KEY); } catch { /* ignore */ } };

const lapi = axios.create({ baseURL: API });
lapi.interceptors.request.use((c) => {
  const t = getLToken();
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export default lapi;
